import produce from 'immer';
import { IItem } from 'models/item';
import { TConcept } from 'types';

export type BaseItemInteraction = {
  id: string;
  templateType: string;
  rawItem: IItem;
  updateRawItem: (newRawItem: IItem) => void;
  updateConceptLocally: (conceptId: string, updates: Partial<TConcept>) => void;
};

export type BaseItemServiceParams = {
  item: IItem;
  distractors: any;
  facets: any;
  setItem: (fn: (prevItem: any) => any) => void;
  itemsService: any;
};

export function createBaseItemInteraction(
  params: BaseItemServiceParams,
  templateType: string
): BaseItemInteraction {
  const { item, setItem } = params;
  
  return {
    id: item.id,
    templateType,
    rawItem: item,
    updateRawItem: (newRawItem: IItem) => {
      setItem((prevItem) => {
        return { ...prevItem, rawItem: newRawItem };
      });
    },
    updateConceptLocally: (conceptId: string, updates: Partial<TConcept>) => {
      setItem((prevItem) => {
        return produce(prevItem, (draft) => {
          draft.rawItem.facets = draft.rawItem.facets.map((facet) => {
            if (facet.association.id === conceptId) {
              facet.association = { ...facet.association, ...updates };
            } else if (facet.anchor.id === conceptId) {
              facet.anchor = { ...facet.anchor, ...updates };
            }
            return facet;
          });
        });
      });
    },
  };
}